import slice, { selectors } from './products.slice';
import {
  getProducts,
  getMoreProducts,
  getGeneralConfig
} from './products.thunk';

export const productsActions = {
  ...slice.actions,
  getProducts,
  getMoreProducts,
  getGeneralConfig
};
export const productsReducer = slice.reducer;
export const productsSelectors = selectors;
